import { FC } from 'react';
import { CardFooterProps } from './types';
import { styleCardFooter } from './style';
import clsx from 'clsx';

const CardFooter: FC<CardFooterProps> = (props) => {
  const { className, children, dim, ...rest } = props;

  const cls = styleCardFooter(props);
  return (
    <div className={clsx(cls.main, className)} {...rest}>
      {children}
    </div>
  );
};

export default CardFooter;
